import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CateringSiteComponent } from './catering-site.component';

import { HomepageComponent } from './components/homepage/homepage.component';
import { AboutComponent } from './components/about/about.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { ContactComponent } from './components/contact/contact.component';

/* Menu */

import { AudienceListComponent } from './components/menu/audience-list/audience-list.component';
import { AudienceViewComponent } from './components/menu/audience-view/audience-view.component';
import { PoliciesComponent } from './components/policies/policies.component';

import { AudienceViewResolver } from '@service/resolvers/audience-view.resolver';


const routes: Routes = [
  {
    path: '', component: CateringSiteComponent,
    children: [
      { path: '', component: HomepageComponent },
      { path: 'about', component: AboutComponent },
      { path: 'gallery', component: GalleryComponent },
      { path: 'contact', component: ContactComponent },
      { path: 'menu', component: AudienceListComponent },
      { path: 'policies', component: PoliciesComponent },
      { path: 'menu/:id', component: AudienceViewComponent, resolve: { data: AudienceViewResolver }, },
      { path: '**', loadChildren: () => import('@module/not-found/not-found.module').then(m => m.NotFoundModule) },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CateringSiteRoutingModule { }
